import { type ReactNode, useContext } from "react";
import { createPortal } from "react-dom";

import { NavHeaderContext } from "./NavHeaderContext";

export const useNavHeader = (node: ReactNode): ReactNode => {
  const { container } = useContext(NavHeaderContext);
  if (!container) return null;

  return createPortal(node, container);
};
